module.exports = __webpack_public_path__ + "img/elha-logo-green-white.3e52e2b0.svg";